import React from 'react'
import { Modal, Button } from 'antd'
import styled from '@emotion/styled'
import { StyledButton } from '../../styles'

interface LocationSectionProps {
  selectedRows: string[]
  isOpen: boolean
  onOk: () => void
  onCancel: () => void
}

const DisconnectLocationModal = ({
  selectedRows,
  onCancel,
  onOk,
  isOpen
}: LocationSectionProps) => {
  const handleOk = () => {
    onOk()
  }

  const handleCancel = () => {
    onCancel()
  }

  return (
    <Modal
      open={isOpen}
      onCancel={handleCancel}
      closable={false}
      footer={false}
    >
      <ModalTitle>Remove location connection</ModalTitle>
      <ModalDescription>
        This will remove the connection between the following store(s) and their
        Lightspeed location:
      </ModalDescription>

      <ModalDescription>
        <List>
          {selectedRows.map((row) => (
            <li key={row}>{row}</li>
          ))}
        </List>
      </ModalDescription>

      <ModalDescription>
        These stores will lose access to Lightspeed menus and you’ll need to
        reconnect them to assign menus again
      </ModalDescription>

      <Actions>
        <StyledButton type='primary' onClick={handleCancel}>
          Cancel
        </StyledButton>
        <DisconnectButton type='primary' onClick={handleOk}>
          Remove connection
        </DisconnectButton>
      </Actions>
    </Modal>
  )
}

const List = styled.ul`
  padding-left: 22px;
`

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 500;
  color: #4a4a68;
  margin-bottom: 32px;
`

const ModalDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #4a4a68;
  line-height: 1;
  margin-bottom: 16px;
`

const Actions = styled.div`
  margin-top: 32px;

  display: flex;
  justify-content: flex-end;
  gap: 16px;
`

const DisconnectButton = styled(Button)`
  background: #a40000;
  color: #fff;

  &:hover,
  &:focus,
  &:active {
    background: #a40000;
    color: #fff;
  }
`

export default DisconnectLocationModal
